import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  InputTypeMap,
} from "@mui/joy";
import { ReactNode, useCallback } from "react";
import { Observable, Subject } from "rxjs";
import { useRxVal } from "../hooks/useRx";
import { SxProps } from "@mui/joy/styles/types";

export interface TextInput$Props {
  label?: string | ReactNode;
  val$: Subject<string>;
  error$?: Observable<string | null>;
  showError?: boolean;
  required?: boolean;
  containerSx?: SxProps;
  helper?: string;
}

export function XTextInput({
  val$,
  error$,
  showError,
  label,
  required,
  containerSx,
  helper,
  ...props
}: InputTypeMap<{}, "div">["props"] & TextInput$Props) {
  const val = useRxVal(val$);
  const error = useRxVal(error$);

  const handleChanges = useCallback(
    (e: React.FocusEvent<HTMLInputElement, Element>) => {
      val$.next(e.target.value);
    },
    [val$]
  );

  return (
    <FormControl
      required={required}
      error={showError && !!error}
      sx={containerSx}
    >
      {label && <FormLabel>{label}</FormLabel>}
      {helper && <FormHelperText>{helper}</FormHelperText>}
      <Input
        {...props}
        size="md"
        onChange={handleChanges}
        onBlur={handleChanges}
        value={val}
      />
      {showError && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
